import React, { useEffect, useState } from 'react';

import { Breadcrumb } from 'antd';
import classNames from 'classnames';
import styled from 'styled-components';

import { useSettingsContext } from './SettingsContext';

const StyledBreadcrumb = styled(Breadcrumb)`
  font-size: 12px;
  li {
    &:first-child {
      color: var(--dark-blue);
    }
    &:last-child {
      color: var(--text-secondary);
    }
    &.ant-breadcrumb-separator {
      margin-inline: 4px;
    }
  }
`;

type Props = {
  showAllSettings: boolean;
};

const SettingsBreadcrumbs = ({ showAllSettings }: Props) => {
  const [items, setItems] = useState<any>([]);
  const { headerContent } = useSettingsContext();

  useEffect(() => {
    if (!showAllSettings) {
      const classes = classNames({
        'dark-blue': showAllSettings,
      });
      setItems([
        {
          title: 'Settings',
          className: classes,
        },
        { title: headerContent?.section },
      ]);
    }
  }, [headerContent]);

  return <StyledBreadcrumb items={items} separator="·" />;
};

export default SettingsBreadcrumbs;
